<template>
    <div class="log-container">
        <div class="header">
            <el-button type="primary" @click="openModal" size="small">新增任务</el-button>
        </div>
        <div class="table-main">
            <el-table
                    :header-cell-style="{ 'text-align': 'center',background:'#f5f7fa',color:'#606266' }"
                    :cell-style="{ 'text-align': 'center' }"
                    border
                    :data="tableData"
                    style="width: 100%">
                <el-table-column
                        prop="jobKey"
                        label="JobKey"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="desc"
                        label="描述"
                        width="250">
                </el-table-column>
                <el-table-column
                        prop="runs"
                        width="250"
                        label="运行模式">
                </el-table-column>
                <el-table-column
                        prop="cron"
                        width="150"
                        label="Cron">
                </el-table-column>
                <el-table-column
                        prop="user"
                        width="100"
                        label="负责人">
                </el-table-column>
                <el-table-column
                        prop="status"
                        width="100"
                        label="状态">
                    <template slot-scope="scope">
                        <el-tag size="mini" effect="dark" type="success">{{scope.row.status}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="address"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini">执行</el-button>
                        <el-button type="primary" size="mini">暂停</el-button>
                        <el-button type="primary" size="mini">日志</el-button>
                        <el-button type="primary" size="mini">编辑</el-button>
                        <el-button type="primary" size="mini">GLUE</el-button>
                        <el-button type="danger" size="mini">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination-box">
            <el-pagination
                    background
                    :current-page="current"
                    :page-size="size"
                    layout="sizes,total, prev, pager, next"
                    :page-sizes="[10, 20, 30, 40]"
                    :total="total"
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
            />
        </div>
        <taskModal ref="taskModal" @ok="isOk"></taskModal>

    </div>
</template>

<script>
    import taskModal from './components/taskModal';
    export default {
        components:{
            taskModal
        },
        data() {
            return {
                tableData: [
                    {
                        jobKey:'1_35',
                        desc:'测试偶任务123123123123',
                        runs:'GLUE模式（javascript）',
                        cron:'123123123',
                        user:'王宁王宁',
                        status:'success',
                    },
                    {
                        jobKey:'1_35',
                        desc:'测试偶任务123123123123',
                        runs:'GLUE模式（javascript）',
                        cron:'123123123',
                        user:'王宁王宁',
                        status:'success',
                    },
                    {
                        jobKey:'1_35',
                        desc:'测试偶任务123123123123',
                        runs:'GLUE模式（javascript）',
                        cron:'123123123',
                        user:'王宁王宁',
                        status:'success',
                    },
                    {
                        jobKey:'1_35',
                        desc:'测试偶任务123123123123',
                        runs:'GLUE模式（javascript）',
                        cron:'123123123',
                        user:'王宁王宁',
                        status:'success',
                    },
                    {
                        jobKey:'1_35',
                        desc:'测试偶任务123123123123',
                        runs:'GLUE模式（javascript）',
                        cron:'123123123',
                        user:'王宁王宁',
                        status:'success',
                    },
                ],
                size:50,
                current:1,
                total:500,
            }
        },
        methods:{
            //分页设置
            handleCurrentChange(val){
                this.current = val;
            },
            handleSizeChange(val){
                this.size = val;
                this.current = 1;
                this.getList();
            },
            openModal(){
                this.$refs.taskModal.showModal= true;
            }
        }
    }
</script>

<style scoped lang="scss">
    .log-container{
        background-color: #fff;
        padding: 20px;
        .header{
            display: flex;
            justify-content: right;
            margin-bottom: 20px;
        }
        /*全局分页样式配置*/
        .pagination-box {
            display: flex;
            justify-content: center;
            box-sizing: border-box;
            width: 100%;
            padding: 30px 20px 5px 20px;
        }
    }
</style>
